import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useAuthentication } from 'wmic-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { Flex, FlexItem } from '@jutro/layout';
import { useModal } from '@jutro/components';
import { PolicyService } from 'gw-capability-policy';
import { LobIconUtil, LOBConstants } from 'wmic-portals-utils-js';
import styles from './WMICRcn.module.scss';
import messages from './WMICRcn.messages';
import WMICRcnModal from './WMICRcnModal';

const WMICRcn = ({ policyPeriodData, openModalOnRender, onClose, hideRcnCta }) => {
    const modalApi = useModal();
    const translator = useTranslator();
    const { authHeader, userInfo: authUserData } = useAuthentication();

    const triggerModal = useCallback(async () => {
        let policyDetails;
        if(policyPeriodData.policyNumber){
            policyDetails = await PolicyService.getAccountPolicyDetails_WMIC(policyPeriodData.policyNumber, policyPeriodData.policyTermNumber, authHeader, authUserData.firstName, authUserData.lastName);
            await modalApi.showModal(
                <WMICRcnModal
                    onClose={onClose}
                    policyDetails={policyDetails}
                    hideRcnCta={hideRcnCta}
                />
            );
        }
    }, [onClose]);

    useEffect(() => {
        if (openModalOnRender) {
            triggerModal();
        }
    }, [openModalOnRender, triggerModal]);


    const getIconClass = () => {
        const icon = LobIconUtil.getWmicIcon(policyPeriodData.lob);
        return `fa ${icon} titleIconOrange`;
    }

    return (
        <section role='alert'>
            <button
                role='link'
                className={cx('ww-link-button', styles.card)}
                onClick={() => triggerModal()}
            >
                <Flex alignItems="center">
                    <FlexItem>
                        <i className={`${styles.icon} ${getIconClass()}`} />
                    </FlexItem>
                    <FlexItem textAlign="left">
                        <h2>
                            { policyPeriodData.lob === LOBConstants.PA_LINE ? translator(messages.yourAutoInsuranceIncreased) : translator(messages.yourHomeownersInsuranceIncreased) }
                        </h2>
                        {<div>
                            {translator(messages.policy, { policyNumber: policyPeriodData.policyNumber })}
                        </div>}
                    </FlexItem>
                </Flex>
            </button>
        </section>
    );
};

WMICRcn.propTypes = {
    onClick: PropTypes.func.isRequired,
    policyPeriodData: PropTypes.arrayOf(
            PropTypes.shape({
                policyNumber: PropTypes.string,
                termNumber: PropTypes.integer,
                lob: PropTypes.string
            })
        ).isRequired
};

export default WMICRcn;